import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['menu']

  open() {
    const mobileNav = this.menuTarget
    mobileNav.setAttribute('aria-hidden', 'false')
    mobileNav.classList.add('nav-mobile--is-active')
    mobileNav.focus()
  }

  close(event) {
    if (event.keyCode === 27 || event.type === 'click') {
      const mobileNav = this.menuTarget
      mobileNav.setAttribute('aria-hidden', 'true')
      mobileNav.classList.remove('nav-mobile--is-active')
    }
  }
}
